import type { PlanDefinition } from "@medplum/fhirtypes";
import { PLAN_DEFINITION_COLLECTION_NAME } from "../../fhir";
import { createSubscriptionHook } from "./create-subscription-hook";

/**
 * Hook that subscribes to PlanDefinition resource changes via WebSocket
 * and updates the TanStack DB collection in real-time.
 *
 * Must be used inside FhirDataStoreProvider.
 */
export const usePlanDefinitionSubscription = createSubscriptionHook<PlanDefinition>(
  "PlanDefinition",
  PLAN_DEFINITION_COLLECTION_NAME,
);
